import { getUploadingResourceHint, isLargeFileResourceType } from 'src/data/performance';

export const getUploadingResourceTooltip = (resource) => {
  if (!resource) {
    return '';
  }
  if (isLargeFileResourceType(resource.contentType)) {
    return getUploadingResourceHint({
      resourceType: resource.contentType,
      fileSize: resource.file?.size,
    });
  }
  return resource?.label || resource?.name;
};
